import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getFeatureFlags, setFeatureFlag } from '../services/featureService';

const FeatureFlagsContext = createContext(null);

const DEFAULT_FLAGS = {
  signup_enabled:               true,
  marketing_video_enabled:      true,
  sight_words_tier2_enabled:    false,
  sight_words_tier3_enabled:    false,
  scramble_words_tier2_enabled: false,
  scramble_words_tier3_enabled: false,
  category_words_tier2_enabled: false,
  category_words_tier3_enabled: false,
  math_concepts_enabled:        true,
  daily_living_enabled:         true,
};

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(DEFAULT_FLAGS);
  const [loading, setLoading] = useState(true);

  const loadFlags = useCallback(async () => {
    const { data } = await getFeatureFlags();
    if (data) setFlags(prev => ({ ...prev, ...data }));
    setLoading(false);
  }, []);

  useEffect(() => { loadFlags(); }, [loadFlags]);

  const toggleFlag = useCallback(async (key, enabled) => {
    // Optimistic update
    setFlags(prev => ({ ...prev, [key]: enabled }));
    const { error } = await setFeatureFlag(key, enabled);
    if (error) {
      // Revert on failure
      setFlags(prev => ({ ...prev, [key]: !enabled }));
    }
  }, []);

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, toggleFlag, reloadFlags: loadFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const ctx = useContext(FeatureFlagsContext);
  if (!ctx) throw new Error('useFeatureFlags must be used inside FeatureFlagsProvider');
  return ctx;
};
